import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import TitleHeader from 'components/presenters/header/TitleHeader';
import Fitgrouplist from '../components/grouppage/fitgroup/fitgroupdetail/Fitgrouplist';
import serverController from '../server/serverController';

export default function MypagePitgroup({ match }) {
  const [currentPostIndex, setCurrentPostIndex] = useState(0);
  const [lastIndexNo, setLastIndexNo] = useState(null);
  const [lastLoaded, setLastLoaded] = useState(false);

  // 모임 리스트 데이터 받기
  const [groupslist, setGroupslist] = useState([]);
  const initGroupInfoCallBack = (jsonData) => {
    if (jsonData.success !== 1) {
      alert('예기치 못한 오류가 발생하였습니다.');
      return;
    } else {
      // setLastIndexNo
      // lastIndexNo
      let groupList = jsonData.data.groups;
      if (groupList.length > 0) {
        let lastLoadedIndex = parseInt(groupList.length) - 1;
        setLastIndexNo(groupList[lastLoadedIndex]['no']);
      } else if (groupList.length === 0) {
        setLastLoaded(true);
      }
      setGroupslist(jsonData.data.groups);
    }
  };
  const groupInfoCallBack = (jsonData) => {
    if (jsonData.success !== 1) {
      alert('예기치 못한 오류가 발생하였습니다.');
      return;
    } else {
      // setLastIndexNo
      // lastIndexNo
      let groupList = jsonData.data.groups;
      if (groupList.length > 0) {
        let lastLoadedIndex = parseInt(groupList.length) - 1;
        setLastIndexNo(groupList[lastLoadedIndex]['no']);
      } else if (groupList.length === 0) {
        setLastLoaded(true);
      }

      setGroupslist(groupslist.concat(jsonData.data.groups));
    }
  };
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    serverController.getServerData(
      `users/${match.params.id}/groups`,
      initGroupInfoCallBack,
    );
  }, []);

  //모임 삭제
  const callBack = (res) => {
    if (res.success === 1) {
      window.location.reload();
    } else {
      alert('예기치 못한 오류가 발생하였습니다.');
    }
  };
  const dataSubmit = () => {
    let data = {};
    serverController.updateFileDeleteFetchController(
      `groups/${currentPostIndex}`,
      JSON.stringify(data),
      callBack,
    );
  };

  // 탈퇴하기
  const deleteCallBack = (res) => {
    if (res.success === 1) {
      window.location.reload();
      //serverController.getServerData("auth",test);
    } else {
      alert('예기치 못한 오류가 발생하였습니다.');
    }
  };
  const deleteSubmit = () => {
    let data = {};
    serverController.updateFileDeleteFetchController(
      `groups/${currentPostIndex}/members`,
      JSON.stringify(data),
      deleteCallBack,
    );
  };

  const handleScroll = (e) => {
    //if( lastNumber == 0)
    //  return;

    const bottom =
      e.target.scrollHeight - e.target.scrollTop - 100 <= e.target.clientHeight;
    if (bottom && !lastLoaded) {
      serverController.getServerData(
        `users/${match.params.id}/groups?last_pos_no=${lastIndexNo}`,
        groupInfoCallBack,
      );
    }
  };

  return (
    <PitgroupList onScroll={handleScroll}>
      <TitleHeader title={'모임'} borderbottom={'1px solid #d5d5d5'} />
      <Fitgrouplist
        groupslist={groupslist}
        setCurrentPostIndex={setCurrentPostIndex}
        dataSubmit={dataSubmit}
        deleteSubmit={deleteSubmit}
      />
    </PitgroupList>
  );
}

const PitgroupList = styled.div`
  padding: calc(100vw * (51 / 375)) 0 0 0;
  height: 100vh;
  overflow-y: scroll;
`;
